/* eslint-disable */
import {
  saveSession,
  sessionKeys,
  getStorge,
  localKeys,
  format,
  RouterHelper,
  getFromForLog
} from './q_business'
import {
  fetchLocation
} from './q_location'
import qFetch from './qFetch'
import { Sniff } from './q_sniff'
import Vue from 'vue'
// 查询list筛选接口
async function fetchFilterType() {
  let cityId, cityName, cityPart, listUrl
  let urlParam = {}
  const fromForLog = getFromForLog()
  const storgeCity = getStorge(localKeys.SEC_CITY)
  if (storgeCity && storgeCity.cityId) {
    cityId = storgeCity.cityId
    cityPart = storgeCity.cityPart
    cityName = storgeCity.cityName
  } else {
    try {
      const locationInfo = await fetchLocation()
      cityId = locationInfo.cityId
      cityPart = locationInfo.cityPart
      cityName = locationInfo.city
    } catch (e) {
      console.log(e)
    }
  }
  const dateInfo = getStorge(localKeys.VALID_DATE)
  let fromDate, toDate
  if (dateInfo) {
    fromDate = dateInfo.fromDate
    toDate = dateInfo.toDate
  } else {
    let date = new Date()
    fromDate = format('yyyy-MM-dd', date)
    toDate = format('yyyy-MM-dd', new Date(+date.getTime() + 1000 * 60 * 60 * 24))
  }
  if (cityId) {
    urlParam = {
      saveFilter: 2,
      // cityName: cityName || '',
      fromForLog,
      cityId,
      cityPart,
      fromDate,
      toDate
    }
  } else {
    urlParam = {
      saveFilter: 2,
      fromForLog,
      fromDate,
      toDate
    }
  }
  listUrl = RouterHelper('list', urlParam)
  saveSession(sessionKeys.JUMP_LIST_URL, listUrl)
}

// 判断新老客 用新客兜底  1表示老客 2表示新客
const checkUser = () => {
  const url = '/tjbnb/app/user/check'
  return qFetch({
      url
    })
    .then((res) => {
      const {
        newUser
      } = res.data || {}
      if (newUser === false) {
        saveSession(sessionKeys.IS_OLD_USER, 1)
      } else {
        saveSession(sessionKeys.IS_OLD_USER, 2)
      }
    })
    .catch((err) => {
      saveSession(sessionKeys.IS_OLD_USER, 2)
    })
}
const qunarHook = () => {
  // checkUser()
  fetchFilterType()
}

const eventBusV = new Vue()

export {
  qunarHook,
  checkUser,
  eventBusV
}